import { axios, BaseApiUrl} from '../axios_config';

//查询报表
export const getPCLabelChangeListAsync = params => {
    return axios.post(`${BaseApiUrl}/ChangeLabel/GetPCLabelChangeListAsync`, params);
};


//导出
export const exportPCLabelChangeListOut = `${BaseApiUrl}/ChangeLabel/GetPCLabelChangeListOut`;
